export default RAILS_ASSET_URL("/gallery-image-05.webp")
